import SlidePage1 from '../slide_1/SlidePage1';

const menus = [
    { 
        path: '/menu1',
        element: <SlidePage1 />,
        name: '메뉴1'
    },
    { 
        path: '/menu2',
        element: <SlidePage1 />,
        name: '메뉴2'
    },
    { 
        path: '/menu3',
        element: <SlidePage1 />,
        name: '메뉴3'
    },
    { 
        path: '/menu4',
        element: <SlidePage1 />,
        name: '메뉴4'
    }
];

export default menus;
